module.exports = __webpack_public_path__ + "assets/link.83161b36.svg";